import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import {
  DayStats,
  PersistentStats,
  initialPersistentStats,
  initialDayStats,
} from './stats.ruleset';
import {
  incrementDayStat,
  incrementPersistentStat,
  setPersistentStat,
  setDayStat,
} from './stats.modifiers';

export default createActions({
  /**
   * Increase persistent stats of user activity
   */
  incrementPersistentStat: action((state, id: PersistentStats) =>
    incrementPersistentStat(state, id),
  ),

  /**
   * Reset persistent stats of user activity
   */
  resetPersistentStat: action((state, id: PersistentStats) =>
    setPersistentStat(state, id, initialPersistentStats[id]),
  ),

  /**
   * Increase day stats of user activity
   */
  incrementDayStat: action((state, id: DayStats, api) =>
    incrementDayStat(state, id, api.date.now()),
  ),

  /**
   * Reset day stats of user activity
   */
  resetDayStat: action((state, id: DayStats, api) =>
    setDayStat(state, id, initialDayStats[id].initial, api.date.now()),
  ),
});
